import store from '@core/store/store'
import { trackCustomEvent } from './utils/trackCustomEvent'

export const trackEventOutsideComponent = (event: any) => {
  const cookiesSeen = store.getState().persistedSettings.cookiesSeen

  trackCustomEvent(event, cookiesSeen)
}
